import { render, staticRenderFns } from "./StorageRecords.vue?vue&type=template&id=bd628f86&scoped=true&"
import script from "./StorageRecords.vue?vue&type=script&lang=js&"
export * from "./StorageRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd628f86",
  null
  
)

export default component.exports